<div style="width: 100%; height: 100%; overflow: auto">

  <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="row" fxLayoutAlign="start start"
    fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="row">
    <div fxFlex="" fxLayoutAlign="start center">
      <span class="logo-text h1">File 7.1</span>

    </div>
    <div fxFlex fxLayoutAlign="end center">

    </div>

  </div>


  <div class="p-12">
    <div class="p-12">

      <div *ngIf="firstTimeload">

        <span *ngIf="banksLoading">Please wait while we load your transactions.</span>

        <div *ngIf="!banksLoading">
          Looks like you have no accounts on record. <br />
          To proceed please connect an account. <br />
          <button mat-button color="accent" (click)="openCase()">Connect Account</button>
        </div>

        <mat-progress-bar *ngIf="banksLoading" [mode]="progressMode" [value]="progressValue" color="accent">
        </mat-progress-bar>
        <small *ngIf="banksLoading">{{ progressMessage }}</small>

      </div>


      <mat-table *ngIf="!firstTimeload" [dataSource]="transactions" class="mat-elevation-z8">
        <ng-container matColumnDef="date_millisec">
          <mat-header-cell *matHeaderCellDef>Date </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.date_millisec | date}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Description </mat-header-cell>

          <mat-cell *matCellDef="let element">{{cleanDate(element.name)}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef> Category </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.category}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="transaction_type">
          <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
          <mat-cell *matCellDef="let element">{{transactionType(element.transaction_type)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pending">
          <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.pending ? 'Pending' : 'Cleared' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
          <mat-cell *matCellDef="let element">${{element.amount}} </mat-cell>
        </ng-container>
        <!-- TODO if button need to be added -->
        <!--<ngx-datatable-column name="Action" prop="transaction_id" [flexGrow]="1">
          <ng-template let-value="value" ngx-datatable-cell-template>

            <button mat-button color="accent" (click)="editTransaction(value)">
              <i class="material-icons" style="color: #2196F3">mode_edit</i>
            </button>

            <button mat-button color="warn" (click)="deleteTransaction(value)">
              <i class="material-icons" style="color: #F44336">delete_forever</i>
            </button>

          </ng-template>
        </ngx-datatable-column>-->

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <br />

      <button *ngIf="!firstTimeload" [class.loading]="buttonLoading" [disabled]="buttonLoading" mat-raised-button
        color="accent" class="pull-right" (click)="submitSevenOne()">
        <div class="spinner"></div>
        <span class="label">Submit</span>
      </button>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/sevenOne/sevenOne.component.html